<template>
  <!-- eslint-disable max-len -->
  <div class="min-h-full">
    <div class="bg-gray-800 pb-32">
      <AppNavbar />
      <header class="py-10">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 class="text-3xl font-bold text-white">Sollicitations</h1>
        </div>
      </header>
    </div>

    <main class="-mt-32">
      <SollicitationContent
        v-model:displaycontent="displaycontent"
        v-model:sollicitation="chosensollicitation"
        @shut="hideDetailedContent"
      />
      <div class="max-w-7xl mx-auto pb-12 px-4 sm:px-6 lg:px-8">
        <!-- Replace with your content -->
        <div class="bg-white rounded-lg shadow px-5 py-10 sm:px-6">
          <!-- Search sollicitation -->
          <div class="mb-4" v-if="!searchtheme && !usersearch && !selecteddisp">
            <label for="search" class="block text-sm font-medium text-gray-700"
              >Recherchez avec <span class="font-bold">1 mot-clé</span></label
            >
            <div class="mt-1 relative flex items-center">
              <input
                @keyup.enter="searchSollicitations()"
                @keydown.space.prevent
                type="text"
                name="search"
                v-model="search"
                id="search"
                class="
                  shadow-sm
                  focus:ring-indigo-500 focus:border-indigo-500
                  block
                  w-full
                  pr-12
                  sm:text-sm
                  border-gray-300
                  rounded-md
                "
                placeholder="Vous pouvez rechercher un mot clé du titre ou du contenu d'une sollicitation"
              />
              <div class="absolute inset-y-0 right-0 flex py-1.5 pr-1.5">
                <kbd
                  class="
                    inline-flex
                    items-center
                    border border-gray-200
                    rounded
                    px-2
                    text-sm
                    font-sans font-medium
                    text-gray-400
                  "
                >
                  Entrer
                </kbd>
              </div>
            </div>
          </div>
          <!-- Search ends -->
          <!-- Search query -->
          <div class="mb-4 flex" v-if="usersearch">
            Vous avez recherché :
            <span
              class="
                inline-flex
                rounded-full
                items-center
                py-0.5
                pl-2.5
                pr-1
                text-sm
                font-medium
                bg-indigo-100
                text-indigo-700
              "
            >
              {{ usersearch }}
              <button
                @click.prevent="resetSearch"
                type="button"
                class="
                  flex-shrink-0
                  ml-0.5
                  h-4
                  w-4
                  rounded-full
                  inline-flex
                  items-center
                  justify-center
                  text-indigo-400
                  hover:bg-indigo-200 hover:text-indigo-500
                  focus:outline-none focus:bg-indigo-500 focus:text-white
                "
              >
                <span class="sr-only">Réinitialisez</span>
                <svg
                  class="h-2 w-2"
                  stroke="currentColor"
                  fill="none"
                  viewBox="0 0 8 8"
                >
                  <path
                    stroke-linecap="round"
                    stroke-width="1.5"
                    d="M1 1l6 6m0-6L1 7"
                  />
                </svg>
              </button>
            </span>
            <span class="ml-auto"
              >{{ sollicitations.data.length }} résultats possibles</span
            >
          </div>
          <!-- Search query ends -->
          <!-- Filter Sollicitations by Theme -->
          <div class="mb-6" v-if="!searchtheme && !usersearch && !selecteddisp">
            <label
              for="location"
              class="block text-sm font-medium text-gray-700"
            >
              OU <span class="font-bold">par thème</span></label
            >
            <select
              @change="searchSollicitationsByTheme"
              id="theme"
              name="theme"
              v-model="searchtheme"
              class="
                mt-1
                block
                w-full
                pl-3
                pr-10
                py-2
                text-base
                border-gray-300
                focus:outline-none focus:ring-indigo-500 focus:border-indigo-500
                sm:text-sm
                rounded-md
              "
            >
              <option v-for="theme in themes" :key="theme.id" :value="theme">
                {{ theme.title }}
              </option>
            </select>
          </div>
          <div class="mb-4" v-if="searchtheme">
            Vous avez recherché :
            <span
              class="
                inline-flex
                rounded-full
                items-center
                py-0.5
                pl-2.5
                pr-1
                text-sm
                font-medium
                bg-indigo-100
                text-indigo-700
              "
            >
              {{ searchtheme.title }}
              <button
                @click.prevent="resetSearch"
                type="button"
                class="
                  flex-shrink-0
                  ml-0.5
                  h-4
                  w-4
                  rounded-full
                  inline-flex
                  items-center
                  justify-center
                  text-indigo-400
                  hover:bg-indigo-200 hover:text-indigo-500
                  focus:outline-none focus:bg-indigo-500 focus:text-white
                "
              >
                <span class="sr-only">Réinitialisez</span>
                <svg
                  class="h-2 w-2"
                  stroke="currentColor"
                  fill="none"
                  viewBox="0 0 8 8"
                >
                  <path
                    stroke-linecap="round"
                    stroke-width="1.5"
                    d="M1 1l6 6m0-6L1 7"
                  />
                </svg>
              </button>
            </span>
          </div>
          <!-- Filter ends -->
          <!-- Filter Sollicitations by Disp  -->
          <div class="mb-6" v-if="!searchtheme && !usersearch && !selecteddisp">
            <label
              for="location"
              class="block text-sm font-medium text-gray-700"
            >
              OU <span class="font-bold">par l'un de vos DISPs</span></label
            >
            <select
              @change="searchSollicitationsByDisps"
              id="theme"
              name="theme"
              v-model="selecteddisp"
              class="
                mt-1
                block
                w-full
                pl-3
                pr-10
                py-2
                text-base
                border-gray-300
                focus:outline-none focus:ring-indigo-500 focus:border-indigo-500
                sm:text-sm
                rounded-md
              "
            >
              <option v-for="disp in disps" :key="disp.id" :value="disp">
                {{ disp.title }}
              </option>
            </select>
          </div>
          <div class="mb-4" v-if="selecteddisp">
            Vous avez recherché :
            <span
              class="
                inline-flex
                rounded-full
                items-center
                py-0.5
                pl-2.5
                pr-1
                text-sm
                font-medium
                bg-indigo-100
                text-indigo-700
              "
            >
              {{ selecteddisp.title }}
              <button
                @click.prevent="resetSearch"
                type="button"
                class="
                  flex-shrink-0
                  ml-0.5
                  h-4
                  w-4
                  rounded-full
                  inline-flex
                  items-center
                  justify-center
                  text-indigo-400
                  hover:bg-indigo-200 hover:text-indigo-500
                  focus:outline-none focus:bg-indigo-500 focus:text-white
                "
              >
                <span class="sr-only">Réinitialisez</span>
                <svg
                  class="h-2 w-2"
                  stroke="currentColor"
                  fill="none"
                  viewBox="0 0 8 8"
                >
                  <path
                    stroke-linecap="round"
                    stroke-width="1.5"
                    d="M1 1l6 6m0-6L1 7"
                  />
                </svg>
              </button>
            </span>
          </div>
          <!-- Filter ends -->
          <div v-if="sollicitations.data">
            <div class="flex flex-col" v-if="sollicitations.data.length > 0">
              <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                <div
                  class="
                    py-2
                    align-middle
                    inline-block
                    min-w-full
                    sm:px-6
                    lg:px-8
                  "
                >
                  <div
                    class="
                      shadow
                      overflow-hidden
                      border-b border-gray-200
                      sm:rounded-lg
                    "
                  >
                    <table class="min-w-full divide-y divide-gray-200">
                      <thead class="bg-gray-50">
                        <tr>
                          <th
                            scope="col"
                            class="
                              px-6
                              py-3
                              text-left text-xs
                              font-medium
                              text-gray-500
                              uppercase
                              tracking-wider
                            "
                          >
                            Établissement concerné / date
                          </th>
                          <th
                            scope="col"
                            class="
                              px-6
                              py-3
                              text-left text-xs
                              font-medium
                              text-gray-500
                              uppercase
                              tracking-wider
                            "
                          >
                            Titre
                          </th>
                          <th
                            scope="col"
                            class="
                              px-6
                              py-3
                              text-left text-xs
                              font-medium
                              text-gray-500
                              uppercase
                              tracking-wider
                            "
                          >
                            Statut
                          </th>
                          <th
                            scope="col"
                            class="
                              px-6
                              py-3
                              text-left text-xs
                              font-medium
                              text-gray-500
                              uppercase
                              tracking-wider
                            "
                          >
                            Priorité
                          </th>
                          <th
                            scope="col"
                            class="
                              px-6
                              py-3
                              text-left text-xs
                              font-medium
                              text-gray-500
                              uppercase
                              tracking-wider
                            "
                          >
                            Personne(s) concernée(s)
                          </th>
                          <th
                            scope="col"
                            class="
                              px-6
                              py-3
                              text-left text-xs
                              font-medium
                              text-gray-500
                              uppercase
                              tracking-wider
                            "
                          >
                            Thème / Sous-thème
                          </th>
                          <th
                            scope="col"
                            class="
                              px-6
                              py-3
                              text-left text-xs
                              font-medium
                              text-gray-500
                              uppercase
                              tracking-wider
                            "
                          >
                            Descriptif
                          </th>
                          <th scope="col" class="relative px-6 py-3">
                            <span class="sr-only">Voir le détail</span>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(
                            sollicitation, sollicitationIdx
                          ) in sollicitations.data"
                          :key="sollicitation.id"
                          :class="
                            sollicitationIdx % 2 === 0
                              ? 'bg-white'
                              : 'bg-gray-50'
                          "
                        >
                          <td
                            class="px-6 py-4 text-sm font-medium text-gray-500"
                          >
                            <span
                              style="font-weight: bold"
                              v-if="sollicitation.prison"
                              >{{ sollicitation.prison.title }}</span
                            >
                            <br />
                            {{
                              moment(sollicitation.date).format(
                                "dddd DD MMMM YYYY à HH:mm"
                              )
                            }}
                          </td>
                          <td
                            class="px-6 py-4 text-sm font-medium text-gray-900"
                          >
                            {{ sollicitation.title }}
                          </td>
                          <td
                            v-if="sollicitation.status"
                            class="px-6 py-4 text-sm font-medium text-gray-900"
                          >
                            <span
                              v-if="sollicitation.status == 'Active'"
                              class="
                                inline-flex
                                items-center
                                px-2.5
                                py-0.5
                                rounded-full
                                text-xs
                                font-medium
                                bg-green-100
                                text-green-800
                              "
                            >
                              {{ sollicitation.status }}
                            </span>
                            <span
                              v-else
                              class="
                                inline-flex
                                items-center
                                px-2.5
                                py-0.5
                                rounded-full
                                text-xs
                                font-medium
                                bg-red-100
                                text-red-800
                              "
                            >
                              {{ sollicitation.status }}
                            </span>
                          </td>
                          <td
                            v-if="sollicitation.status"
                            class="px-6 py-4 text-sm font-medium text-gray-900"
                          >
                            <span
                              v-if="sollicitation.is_urgent == false"
                              class="
                                inline-flex
                                items-center
                                px-2.5
                                py-0.5
                                rounded-full
                                text-xs
                                font-medium
                                bg-green-100
                                text-green-800
                              "
                            >
                              Normale
                            </span>
                            <span
                              v-else
                              class="
                                inline-flex
                                items-center
                                px-2.5
                                py-0.5
                                rounded-full
                                text-xs
                                font-medium
                                bg-red-100
                                text-red-800
                              "
                            >
                              Urgente !
                            </span>
                          </td>
                          <td class="px-6 py-4 text-sm text-gray-500">
                            <ul>
                              <li
                                v-for="inmate in sollicitation.inmates"
                                :key="inmate.id"
                              >
                                {{ inmate.firstname }} {{ inmate.lastname }}
                              </li>
                            </ul>
                          </td>
                          <td class="px-6 py-4 text-sm text-gray-500">
                            <span style="font-weight: bold">{{
                              sollicitation.theme.title
                            }}</span>
                            <br />
                            <span v-if="sollicitation.subtheme">{{
                              sollicitation.subtheme.title
                            }}</span>
                          </td>
                          <td
                            class="px-6 py-4 text-sm font-medium text-gray-500"
                          >
                            <button
                              @click.prevent="displayDetail(sollicitation)"
                              type="button"
                              class="p-1 rounded-full hover:text-white"
                            >
                              <AnnotationIcon
                                class="
                                  flex-shrink-0
                                  mr-1.5
                                  h-5
                                  w-5
                                  text-gray-400
                                "
                                aria-hidden="true"
                              />
                            </button>
                          </td>
                          <td
                            class="
                              px-6
                              py-4
                              whitespace-nowrap
                              text-right text-sm
                              font-medium
                            "
                          >
                            <a
                              :href="/sollicitations/ + sollicitation.id"
                              target="_blank"
                              class="text-indigo-600 hover:text-indigo-900"
                              >En détails</a
                            >
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- pagination  -->
          <div v-if="sollicitations.data">
            <div v-if="sollicitations.data.length > 0">
              <nav
                v-if="!usersearch && !selecteddisp && !searchtheme"
                class="
                  bg-white
                  px-4
                  py-3
                  flex
                  items-center
                  justify-between
                  border-t border-gray-200
                  sm:px-6
                "
                aria-label="Pagination"
              >
                <div class="hidden sm:block">
                  <p class="text-sm text-gray-700">
                    Page
                    {{ " " }}
                    <span class="font-medium">{{ currentpage }}</span>
                    {{ " " }}
                    sur
                    {{ " " }}
                    <span class="font-medium">{{
                      sollicitations.last_page
                    }}</span>
                    {{ " " }}
                    de
                    {{ " " }}
                    <span class="font-medium">{{ sollicitations.total }}</span>
                    {{ " " }}
                    résultats
                  </p>
                </div>
                <div class="flex-1 flex justify-between sm:justify-end">
                  <button
                    @click.prevent="goPreviouspage"
                    :disabled="currentpage < 2"
                    :class="currentpage < 2 ? 'cursor-not-allowed' : ''"
                    class="
                      relative
                      inline-flex
                      items-center
                      px-4
                      py-2
                      border border-gray-300
                      text-sm
                      font-medium
                      rounded-md
                      text-gray-700
                      bg-white
                      hover:bg-gray-50
                      cursor-pointer
                    "
                  >
                    Précédentes
                  </button>
                  <button
                    @click.prevent="goNextpage"
                    :disabled="currentpage == sollicitations.last_page"
                    :class="
                      currentpage == sollicitations.last_page
                        ? 'cursor-not-allowed'
                        : ''
                    "
                    class="
                      ml-3
                      relative
                      inline-flex
                      items-center
                      px-4
                      py-2
                      border border-gray-300
                      text-sm
                      font-medium
                      rounded-md
                      text-gray-700
                      bg-white
                      hover:bg-gray-50
                      cursor-pointer
                    "
                  >
                    Suivantes
                  </button>
                </div>
              </nav>
            </div>
          </div>
          <!-- pagination ends -->
        </div>
        <!-- /End replace -->
      </div>
    </main>
  </div>
</template>

<script>
import { ref } from 'vue';
import moment from 'moment';
import 'moment/locale/fr';
import AppNavbar from '@/components/AppNavbar.vue';
import { AnnotationIcon } from '@heroicons/vue/solid';
import SollicitationContent from '@/components/Modals/SollicitationContent.vue';

const search = ref();
const sollicitations = ref([]);
const currentpage = ref();
const usersearch = ref();
const themes = ref();
const disps = ref();
const searchtheme = ref();
const selecteddisp = ref();
const currentuser = ref();
const displaycontent = ref(false);

export default {
  components: {
    AppNavbar,
    AnnotationIcon,
    SollicitationContent,
  },
  setup() {
    return {
      search,
      sollicitations,
      currentpage,
      usersearch,
      themes,
      searchtheme,
      selecteddisp,
      currentuser,
      disps,
      displaycontent,
    };
  },
  created() {
    this.moment = moment;
    this.currentpage = 1;
    this.getResults();
    this.getThemes();
    if (localStorage.user) {
      this.currentuser = JSON.parse(localStorage.user);
    }
  },
  mounted() {
    this.getDisps();
  },
  watch: {
    user(newUser) {
      localStorage.user = newUser;
    },
  },
  methods: {
    getThemes() {
      this.$http.get('/api/sollicitations-themes')
        .then((response) => {
          this.themes = response.data;
        })
        .catch((error) => {
          window.console.log(error);
          this.errored = true;
        });
    },
    getDisps() {
      this.$http.get(`/api/mydisps/${this.currentuser.id}`)
        .then((response) => {
          this.disps = response.data;
        })
        .catch((error) => {
          window.console.log(error);
          this.errored = true;
        });
    },
    getResults() {
      this.$http.get(`api/sollicitations?page=${this.currentpage}`)
        .then((response) => {
          this.sollicitations = response.data;
        })
        .catch((error) => {
          window.console.log(error);
          this.errored = true;
        });
    },
    goNextpage() {
      this.currentpage += 1;
      this.getResults();
    },
    goPreviouspage() {
      this.currentpage -= 1;
      this.getResults();
    },
    searchSollicitations() {
      this.usersearch = this.search;
      this.$http.get(`api/sollicitations-search/${this.search}`)
        .then((response) => {
          this.sollicitations.data = response.data;
        })
        .catch((error) => {
          window.console.log(error);
          this.errored = true;
        });
    },
    resetSearch() {
      this.usersearch = null;
      this.search = null;
      this.searchtheme = null;
      this.selecteddisp = null;
      this.getResults();
    },
    searchSollicitationsByTheme() {
      this.$http.get(`api/sollicitations-theme/${this.searchtheme.id}`)
        .then((response) => {
          this.sollicitations.data = response.data;
        })
        .catch((error) => {
          window.console.log(error);
          this.errored = true;
        });
    },
    searchSollicitationsByDisps() {
      this.$http.get(`api/sollicitations-disp/${this.selecteddisp.id}`)
        .then((response) => {
          this.sollicitations.data = response.data;
        })
        .catch((error) => {
          window.console.log(error);
          this.errored = true;
        });
    },
    displayDetail(detailedSollicitation) {
      this.chosensollicitation = detailedSollicitation;
      this.displaycontent = true;
    },
    hideDetailedContent() {
      this.chosensollicitation = null;
      this.displaycontent = false;
    },
  },
};
</script>
